import { numericRegex as numericQuantityRegex } from 'numeric-quantity'

const numericRegex = new RegExp(numericQuantityRegex.source.replace(/^\^/, '^\\s*').replace(/\$$/, '\\s*$'))

export const isValidValue = (v: any) =>
	(typeof v === 'string' && v.length > 0) ||
	(typeof v === 'number' && !Number.isNaN(v)) ||
	(typeof v !== 'string' && typeof v !== 'number')

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const shouldRenderAsNumber = (v: any, parseNumbers?: boolean) =>
	parseNumbers && (typeof v === 'number' || typeof v === 'bigint' || (typeof v === 'string' && numericRegex.test(v)))

export const quoteFieldNamesWithArray = (
	quoteFieldNamesWith: null | string | [string, string] = ['', ''],
): [string, string] => {
	if (Array.isArray(quoteFieldNamesWith)) {
		return quoteFieldNamesWith
	}

	if (typeof quoteFieldNamesWith === 'string') {
		return [quoteFieldNamesWith, quoteFieldNamesWith]
	}

	return quoteFieldNamesWith ?? ['', '']
}
